import type { IconData } from '@stacksjs/iconify-core'

export const bombRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M43.985 8.048a3.9 3.9 0 0 0-4.437.312c.632.813 1.173 1.732 1.442 2.734a4.97 4.97 0 0 1-.004 2.69c-.266.928-.807 1.787-1.598 2.572l-1.21 1.2a19.3 19.3 0 0 1 1.504 7.492c0 10.759-8.786 19.454-19.591 19.454S.5 35.807.5 25.048S9.286 5.594 20.091 5.594c2.678 0 5.232.534 7.558 1.5l1.22-1.209c1.64-1.628 3.483-2.06 5.272-1.588c.917.242 1.766.708 2.53 1.263a7.9 7.9 0 0 1 9.36-.949l.492.293a2 2 0 0 1-2.046 3.437zM20.091 40.502c-8.625 0-15.591-6.934-15.591-15.454S11.466 9.594 20.091 9.594s15.591 6.934 15.591 15.454s-6.965 15.454-15.591 15.454M6.363 25.047a2 2 0 1 0 4 0c0-5.307 4.34-9.636 9.728-9.636a2 2 0 1 0 0-4c-7.567 0-13.728 6.09-13.728 13.636\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bombRemix
